import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './inbox.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  },
})
export default class Inbox extends Vue {
  items = [];
  fields = [
    {
      key: "receiver",
      label: "Sent to"
    },
    {
      key: "message",
      label: "Confirmation message",
    },
    {
      key: "createdOn",
      label: "Time",
    }
  ]

  mounted () {
    this.getCreditBalance();
   }  

  getCreditBalance():void
  {
    _axios.get(`${config.gateway}sms/view`)
    .then(response=>
    {
      this.items = response.data;
    })
    .catch(err=>{console.error(err);});
  }
}
